import React from 'react';
import withRoot from './modules/withRoot';
import Article from './modules/views/articles/Article7';
import { UI_BASE_URL, UI_PRESENTATIONS } from './consts';
import { CssBaseline } from '@mui/material';
import AppFooter from './modules/views/AppFooter';
import AppAppBar from './modules/views/AppAppBar';


const Page = () => (
    <React.Fragment>
        <AppAppBar />
        <CssBaseline />
        <Article
            path={UI_BASE_URL + UI_PRESENTATIONS}
        />
        <AppFooter />
    </React.Fragment>
);

export default withRoot(Page);
